import React, { memo, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { persistViewSwitchAction } from "@default/js/app-actions";
import { useLocation, useNavigate } from "react-router-dom";
import PillBorder from "@default/general-components/pill-border";
import { useWindowScroll } from "react-use";
import { AnimatePresence, motion } from "framer-motion";

const ViewSwitch = memo(function ViewSwitch({ scrollVanish }) {
  const location = useLocation();
  const navigate = useNavigate();

  const mainSettings = useSelector((state) => state.appStore.mainSettings);
  const dispatch = useDispatch();

  const [selectedView, setSelectedView] = useState(0);

  const { y } = useWindowScroll();
  const isTop = y === 0;

  let selectableViews = [
    {
      label: "Conference",
      link: mainSettings?.fieldConferenceOverviewPage,
    },
    {
      label: "Festival",
      link: mainSettings?.fieldFestivalOverviewPage,
    },
  ];

  const toggleViewSwitch = (index) => {
    // Set activated view for highlighting
    setSelectedView(index);
    // Navigate to the overview Page, save the last page to the state to check it inside of app.jsx (to hide the viewSwitch when not needed)
    navigate(selectableViews[index].link?.uri?.path, {
      state: location.pathname,
    });
    // Save Info if ViewSwitch should stay (if user changes from festival overview to conference overview)
    dispatch(persistViewSwitchAction(index === 1));
  };

  const viewSwitchContent = (
    <div className="main-control view-switch header-element navigation-element">
      <PillBorder blurredBackdrop />
      <small className="sr-only label">Festival Branch</small>
      {selectableViews.map((item, index) => (
        <button
          key={index}
          className={
            location.pathname === item.link?.uri?.path
              ? "active font-style-change"
              : "font-style-change"
          }
          onClick={() => toggleViewSwitch(index)}
        >
          <span className="highlighted">{item.label}</span>
          <span className="standard">{item.label}</span>
        </button>
      ))}
    </div>
  );

  if (scrollVanish) {
    return (
      <AnimatePresence>
        {isTop && (
          <motion.div
            className="view-switch-wrapper"
            initial={{ opacity: 0, filter: "blur(30px)" }}
            animate={{ opacity: 1, filter: "blur(0)" }}
            exit={{ opacity: 0, filter: "blur(30px)" }}
          >
            {viewSwitchContent}
          </motion.div>
        )}
      </AnimatePresence>
    );
  }

  return <div className="view-switch-wrapper">{viewSwitchContent}</div>;
});

ViewSwitch.propTypes = {
  views: PropTypes.array,
  defaultView: PropTypes.string,
  scrollVanish: PropTypes.bool,
};

export default ViewSwitch;
